import { AudioState } from '../../types/audioTypes'
export const selectAllAudios = (state: { audio: AudioState }) =>
  state.audio.audioPodcasts
export const selectCurrentAudio = (state: { audio: AudioState }) =>
  state.audio.currentAudio
export const selectCurrentIndex = (state: { audio: AudioState }) =>
  state.audio.currentIndex
export const selectIsAudioLoading = (state: { audio: AudioState }) =>
  state.audio.isLoading
export const selectIsPlaying = (state: { audio: AudioState }) =>
  state.audio.isPlaying
export const selectPlayBackText = (state: { audio: AudioState }) =>
  state.audio.playBackText
export const selectError = (state: { audio: AudioState }) => state.audio.error
export const selectAudioProgressById =
  (id: string) => (state: { audio: AudioState }) => {
    const audio = state.audio.audioPodcasts.find((audio) => audio.id === id)
    return audio?.progress || 0
  }
